import React from 'react';
import TetrisBackground from './TetrisBackground';
import TopBanner from './TopBanner';
import Hero from './Hero';
import HackathonTimeline from './HackathonTimeline';
import HackathonCTA from './HackathonCTA';
import HackathonCTA2 from './HackathonCTA2';
import HackathonFAQs from './HackathonFAQs';
import HackathonEligibility from './HackathonEligibility';
import HackathonResources from './HackathonResources';
import HackathonFooter from './HackathonFooter';
import HackathonPrizes from './HackathonPrizes';

const HackathonPage: React.FC = () => {
  return (
    <div className="relative overflow-hidden bg-white">
      <TetrisBackground />
      <div className="relative z-10">
        <TopBanner />
        <Hero />
        <HackathonEligibility />
        <HackathonPrizes />
        <HackathonCTA2 />
        <div className="relative z-10">
          <HackathonTimeline />
          <HackathonFAQs />
          <HackathonCTA />
          <HackathonResources />
        </div>
      </div>
    </div>
  );
};

export default HackathonPage; 